import React, { useState, useEffect } from "react";
import {
  Cascader,
  InputNumber,
  Select,
  Col,
  Table,
  Modal,
  message,
  Button,
  Popconfirm,
  Form,
  Tag,
} from "antd";
import {
  PlusOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { DraggableArea } from "react-draggable-tags";
import InspectionApi from "@api/inspectionnew";
import RoleApi from "@api/role";
import sysApi from "@api/sys";
import stationApi from "@api/station";
import { dictApi } from "@api/newApi";
import SearchForm from "@components/SearchForm";
import HandleButton from "@components/HandleButton";
import { connect } from "react-redux";
import moment from "moment";
import {
  getStationData,
  getTreeData,
  toolMouseTip,
  findCurrentDevices,
} from "@utils/common";
import AddModel from "./add";
import download from "@utils/download";
import "../style.scss";
import "./index.scss";
import DepartmentApi from "../../../api/department";

const runStatusEnum = {
  0: "热备",
  1: "运行",
  "0,1": "热备,运行",
  "1,0": "运行,热备",
};

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
};
const periodAry = ["天", "周", "月", "季度"];
const InspectionCom = (props) => {
  const [loading, setLoading] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);
  const [data, setData] = useState([]); // 表格数据
  const [deleteVisible, setDelVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [editTitle, setEditTitle] = useState("新建巡检标准");
  const [rowParams, setRowParams] = useState();
  const [lineModal, setLineModal] = useState(false);
  const [addLineForm] = Form.useForm();
  const [editLineForm] = Form.useForm();
  const [addLineFormValues, setAddLineFormValues] = useState();
  const [deviceLs, setDeviceLs] = useState([]);
  const [selectDevice, setSelectDevice] = useState();
  const [deviceRouteInfos, setDeviceRouteInfos] = useState([]);
  const [lineStationId, setLineStationId] = useState();
  const [roleLs, setRoleLs] = useState([]); // 角色列表
  const [total, setTotal] = useState(0);
  const [lineModifyModalVisible, setlineModifyModalVisible] = useState(false); // 控制线路修改弹窗是否隐藏
  const [selectList, setSelectList] = useState();
  const [stationData, setStationData] = useState();
  const [linePatrolStandardId, setLinePatrolStandardId] = useState(null);
  const [users, setUsers] = useState([]);
  const [currentTmpType] = useState();
  const [tmpDownModal, setTmpDownModal] = useState(false);
  const [tmpLs, setTmpLs] = useState([]);
  const [infoVisible, setInfoVisible] = useState(false);
  const [detail, setDetail] = useState({});
  const [patrolDepts, setPatrolDepts] = useState([]);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: "",
  });

  const sortList = (tags) => {
    tags.map((item, index) => {
      item.idx = index;
    });
    setDeviceRouteInfos(tags);
  };

  // 搜索
  const [inputList] = useState([
    {
      label: "名称:",
      name: "name",
      message: "请输入标准名称",
      span: 8,
      labelCol: 6,
    },
  ]);

  useEffect(() => {
    getStationList();
    getRoleList();
    getPatrolDepts();
    getTmpList();
  }, []);

  const getPatrolDepts = () => {
    InspectionApi.getPatrolDeptsApi({}).then((res) => {
      setPatrolDepts(res.data);
    });
  };

  const getRoleList = () => {
    RoleApi.query({ pageNum: 1, pageSize: 999 }).then((res) => {
      if (res.status !== "0") return;
      setRoleLs(res.data.data);
    });
  };

  const getTmpList = () => {
    dictApi
      .selectWithClassifyKey({ classifyKey: "patrolTemplateType" })
      .then((res) => {
        if (res.status !== "0") return;
        setTmpLs(res.data);
      });
  };

  // 获取厂站列表
  const getStationList = () => {
    let data = getStationData(
      props.userInfo.stationIds ? props.userInfo.stationIds : "-1",
      props.userInfo.stationAliasName,
    );
    setSelectList([
      {
        attr: { allowClear: true },
        label: "站点:",
        name: "stationId",
        message: "请选择站点",
        options: data,
        span: 8,
        labelCol: 6,
      },
    ]);
    setStationData(data);
  };

  useEffect(() => {
    listByPages();
  }, [searchParams]);

  const listByPages = () => {
    setLoading(true);
    InspectionApi.standQuery({ ...searchParams }).then((res) => {
      setLoading(false);
      if (res.status == 0 && res.data) {
        setData(res.data.data || []);
        setTotal(res.data.total);
      }
    });
  };

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
    };
    setSearchParams(params);
  };

  const changStation = (stationId) => {
    stationApi.getDeviceByStationId({ stationId }).then((res) => {
      if (res.status !== "0") return;
      setDeviceLs(getTreeData(res.data));
    });
  };

  /**
   * 删除规则
   */
  const deletes = (id) => {
    setLoadBtn(true);
    InspectionApi.delete(id)
      .then((res) => {
        setLoadBtn(false);
        if (res.status == 0) {
          setDelVisible(false);
          setRowParams(null);
          message.success("删除成功！");
          listByPages();
        }
      })
      .catch((err) => {
        setLoadBtn(false);
      });
  };

  const getLineLs = (deptId, stationId, id) => {
    setLinePatrolStandardId(id);
    setLineStationId(stationId);
    InspectionApi.lineList({ stationId, patrolStandardId: id }).then((res) => {
      if (res.status !== "0") return;
      res.data.routeInfos.map((_t) => (_t.id = _t.idx));
      const userId = res.data.userId ? `${res.data.userId}` : undefined;
      setDeviceRouteInfos(res.data.routeInfos);
      setlineModifyModalVisible(true);
      editLineForm.setFieldsValue({ userId });
    });
    DepartmentApi.getUsersByDeptId({ deptId }).then((res) => {
      if (res.status !== "0") return;
      setUsers(res.data);
    });
  };

  const addItemDeviceLine = () => {
    if (!selectDevice) return message.error("请选择巡检设备");
    const ary = deviceRouteInfos;
    ary.push({
      deviceRelevancyId: selectDevice[selectDevice.length - 1],
      idx: ary.length,
      itemName: findCurrentDevices(
        deviceLs,
        selectDevice[selectDevice.length - 1],
        [],
      )[0].itemName,
    });
    setDeviceRouteInfos([...ary]);
  };

  const addLineItem = () => {
    const params = addLineForm.getFieldValue("deviceRouteInfos");
    params.push({ deviceId: null, idx: 0 });
    addLineForm.setFieldsValue({ deviceRouteInfos: params });
  };

  const removeLineItem = (index) => {
    const params = addLineForm.getFieldValue("deviceRouteInfos");
    params.splice(index, 1);
    addLineForm.setFieldsValue({ deviceRouteInfos: params });
  };

  const submiteAddLine = () => {
    addLineForm.validateFields().then(async (values) => {
      if (!values) return;
      values.deviceRouteInfos.map(
        (item) =>
          (item.deviceRelevancyId =
            item.deviceRelevancyId[item.deviceRelevancyId.length - 1]),
      );
      const res = await InspectionApi.lineAdd(values);
      if (res.status !== "0") return;
      message.success("新增成功");
      addLineForm.resetFields();
      setLineModal(false);
    });
  };

  const closeModalLine = () => {
    addLineForm.resetFields();
    setLineModal(false);
  };

  const submiteModifyLine = () => {
    editLineForm.validateFields().then((values) => {
      if (!values) return;
      const params = {
        patrolStandardId: linePatrolStandardId,
        stationId: lineStationId,
        routeInfos: deviceRouteInfos,
        userId: values.userId,
      };
      InspectionApi.lineUpdate(params).then((res) => {
        if (res.status !== "0") return;
        message.success("修改成功");
        closeLineModifyModal();
      });
    });
  };

  const closeLineModifyModal = () => {
    editLineForm.resetFields();
    setSelectDevice("");
    setDeviceRouteInfos([]);
    setLineStationId(null);
    setlineModifyModalVisible(false);
  };

  const cancel = () => {
    setDelVisible(false);
  };
  const handleConfirm = async (info) => {
    if (info.status === 1) {
      const result = await sysApi.getFlowableId({
        dictType: "sw-flowable",
        dictKey: "patrol_standard_status_disable",
      });
      if (result.status !== "0") return;
      const processId = result.data;
      InspectionApi.standDisenable({ id: info.id * 1, processId }).then(
        (res) => {
          if (res.status === "0") {
            message.success("禁用成功");
            listByPages();
          }
        },
      );
    } else {
      const result = await sysApi.getFlowableId({
        dictType: "sw-flowable",
        dictKey: "patrol_standard_status_enable",
      });
      if (result.status !== "0") return;
      const processId = result.data;
      InspectionApi.standEnable({ id: info.id * 1, processId }).then((res) => {
        if (res.status === "0") {
          message.success("启用成功");
          listByPages();
        }
      });
    }
  };

  const deleteStandar = async (id) => {
    const result = await sysApi.getFlowableId({
      dictType: "sw-flowable",
      dictKey: "patrol_standard_status_delete",
    });
    if (result.status !== "0") return;
    const processId = result.data;
    InspectionApi.standDelete({ id, processId }).then((res) => {
      if (res.status !== "0") return;
      message.success("删除成功");
      listByPages();
    });
  };
  const btnList = [
    {
      title: "新增",
      type: "primary",
      visible:
        props.userInfo.btnResources.indexOf("patrol:standard:add") === -1
          ? false
          : true,
      icon: <PlusOutlined />,
      onClick: () => addShow(),
    },
    {
      title: "新增路线",
      type: "primary",
      visible: false,
      icon: <PlusOutlined />,
      onClick: () => {
        setAddLineFormValues({
          roleId: null,
          stationId: null,
          deviceRouteInfos: [{ deviceRelevancyId: null, idx: 0 }],
        });
        setLineModal(true);
      },
    },
    // {
    //   title: "下载模板",
    //   style: { marginLeft: "10px" },
    //   type: "primary",
    //   visible: true,
    //   icon: <DownloadOutlined />,
    //   onClick: () => {
    //     setTmpDownModal(true);
    //   },
    // },
  ];

  const addShow = () => {
    const params = {
      handleDeptId: null,
      name: "",
      patrolTemplateType: null,
      stationId: null,
      patrolStandardTemplates: [
        {
          deviceRelevancyIds: [],
          patrolTemplateId: null,
          patrolStandardItems: [
            {
              defectLevelId: null,
              itemContent: "",
              lowerLimit: "",
              numericFlag: null,
              runStatus: [],
              safetyPerilFlag: null,
              unit: "",
              upperLimit: "",
              period: null,
              periods: [
                {
                  beginTime: "",
                  date: "",
                  day: null,
                  month: null,
                  period: null,
                  weekDay: null,
                },
              ],
            },
          ],
        },
      ],
    };
    setRowParams(params);
    setEditTitle("新建巡检标准");
    setEditVisible(true);
  };

  const downTmp = (val) => {
    InspectionApi.standardDownloadTemplate({
      templateType: val,
    }).then((res) => {
      setTmpDownModal(false);
      let fileName = "demo.xlsx";
      if (val == "0") {
        fileName = "操作人员巡检标准模板.xlsx";
      } else if (val == "1") {
        fileName = "设备人员巡检标准模板.xlsx";
      } else if (val == "2") {
        fileName = "质安部人员巡检标准模板.xlsx";
      } else if (val == "3") {
        fileName = "工艺部人员巡检标准模板.xlsx";
      } else if (val == "4") {
        fileName = "机关领导人员巡检标准模板.xlsx";
      }
      download(res, fileName);
    });
  };

  const columns = [
    {
      title: "标准名称",
      dataIndex: "name",
      align: "center",
      key: "name",
      render: (_t) => toolMouseTip(_t, 10),
    },
    {
      title: "厂站",
      dataIndex: "stationAliasName",
      align: "center",
      key: "stationAliasName",
    },
    {
      title: "巡检班组",
      dataIndex: "handleDeptName",
      align: "center",
      key: "handleDeptName",
    },
    {
      title: "状态",
      dataIndex: "status",
      align: "center",
      key: "status",
      with: 80,
      render: (obj, record) => {
        return (
          <Tag color={obj ? "#87d068" : "#FF3819"}>
            {" "}
            {obj ? "启用" : "禁用"}{" "}
          </Tag>
        );
      },
    },
    {
      title: "审批状态",
      dataIndex: "approvalStatus",
      align: "center",
      key: "approvalStatus",
      render: (val) => {
        if (val == 1) {
          return <Tag color="#2D99FF">审批中</Tag>;
        } else if (val == 2) {
          return <Tag color="#87d068">通过</Tag>;
        } else if (val == 3) {
          return <Tag color="#FF3819">拒绝</Tag>;
        } else {
          return "-";
        }
      },
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
      align: "center",
      key: "createAt",
      render: (obj) => {
        if (obj) {
          return moment(obj).format("YYYY-MM-DD HH:mm:ss");
        }
      },
    },
    {
      title: "操作",
      key: "operation",
      width: "300px",
      fixed: "right",
      render: (record) => {
        return (
          <>
            <Popconfirm
              title={`确定要${record.status === 0 ? "启用" : "禁用"}模版吗？`}
              onConfirm={() => handleConfirm(record)}
              // onCancel={cancel}
              okText="确定"
              cancelText="取消"
            >
              {props.userInfo.btnResources.indexOf("patrol:standard:enable") !==
                -1 &&
                record.approvalStatus !== 1 &&
                record.status === 0 && (
                  <Button className="success" size="small" type="primary">
                    启用
                  </Button>
                )}
              {props.userInfo.btnResources.indexOf(
                "patrol:standard:disable",
              ) !== -1 &&
                record.approvalStatus !== 1 &&
                record.status !== 0 && (
                  <Button className="deleteBtn" size="small" type="primary">
                    禁用
                  </Button>
                )}
            </Popconfirm>
            {props.userInfo.btnResources.indexOf("patrol:standard:edit") !==
              -1 && (
              <Button
                style={{ marginLeft: "5px" }}
                onClick={() => {
                  InspectionApi.standGetInfo(record.id).then((res) => {
                    if (res.status !== "0") return;
                    setRowParams(res.data);
                    setEditTitle("编辑巡检标准");
                    setEditVisible(true);
                  });
                }}
                className="worningBtn"
                size="small"
                type="primary"
              >
                编辑
              </Button>
            )}
            <Button
              className="worningBtn"
              onClick={() =>
                getLineLs(record.handleDeptId, record.stationId, record.id)
              }
              style={{ marginLeft: "5px" }}
              size="small"
              type="primary"
            >
              线路修改
            </Button>
            <Popconfirm
              title="确定要删除此标准吗"
              onConfirm={() => deleteStandar(record.id)}
              okText="确定"
              cancelText="取消"
            >
              {props.userInfo.btnResources.indexOf("patrol:standard:delete") !==
                -1 && (
                <Button
                  className="deleteBtn"
                  style={{ marginLeft: "5px" }}
                  size="small"
                  type="primary"
                >
                  删除
                </Button>
              )}
            </Popconfirm>
            {props.userInfo.btnResources.indexOf("patrol:standard:info") !==
              -1 && (
              <Button
                style={{ marginLeft: "5px" }}
                onClick={() => {
                  InspectionApi.standGetInfo(record.id).then((res) => {
                    if (res.status !== "0") return;
                    setInfoVisible(true);
                    setDetail(res.data);
                  });
                }}
                size="small"
                type="primary"
              >
                详情
              </Button>
            )}
          </>
        );
      },
    },
  ];
  return (
    <div className="baseContent boundary">
      <div className="title">
        <div style={{ marginLeft: "24px" }}>
          <SearchForm
            searchParams={searchParams}
            span={6}
            inputList={inputList}
            selectList={selectList}
            onSearch={search}
          />
        </div>
        <HandleButton
          btnList={btnList}
          btnStyle={{ padding: "0 24px 20px", textAlign: "right" }}
        />
        <div>
          <Table
            className="Table"
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={(record) => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (total) => `共${total}条数据`,
              total: total,
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>

        {deleteVisible && (
          <Modal
            title="删除站点"
            width={420}
            open={deleteVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={() => deletes(rowParams.id)}
          >
            <div style={{ textAlign: "center", color: "red" }}>
              <p>{`确定要删除巡检模版【${rowParams.templateName}】吗？`}</p>
            </div>
          </Modal>
        )}
        {editVisible && (
          <AddModel
            patrolDepts={patrolDepts}
            tmpLs={tmpLs}
            currentTmpType={currentTmpType}
            stationData={stationData}
            visible={editVisible}
            title={editTitle}
            formData={rowParams}
            cancel={(bool) => {
              setEditVisible(false);
              bool && listByPages();
            }}
          />
        )}
        {/* 线路修改弹窗 */}
        {lineModifyModalVisible && (
          <Modal
            title="线路修改"
            open={true}
            onCancel={closeLineModifyModal}
            onOk={submiteModifyLine}
          >
            <Col>
              <Form
                name="basic"
                form={editLineForm}
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 14,
                }}
                autoComplete="off"
              >
                <Form.Item
                  label="选择用户"
                  name="userId"
                  rules={[
                    {
                      required: true,
                      message: "请选择用户",
                    },
                  ]}
                >
                  {/* <Cascader allowClear options={users} showCheckedStrategy={Cascader.SHOW_CHILD} placeholder="请选择" /> */}
                  <Select
                    optionFilterProp="children"
                    showSearch
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="请选择用户"
                  >
                    {users.length > 0 &&
                      users.map((item) => (
                        <Option value={item.id} key={item.id}>
                          {item.realName}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Form>
              <div className="line-box">
                {/* <div className='new-add-line'>
                <Cascader options={deviceLs} placeholder="请选择设备" value={selectDevice} onChange={(e) => setSelectDevice(e)} />
              </div>
              <Button className='add-line' type='parimary' size='mini' onClick={addItemDeviceLine}>添加</Button> */}
                <div className="Simple">
                  <DraggableArea
                    isList
                    tags={deviceRouteInfos}
                    render={({ tag, index }) => (
                      <div className="tag" key={index}>
                        {tag.itemName}
                      </div>
                    )}
                    onChange={sortList}
                  />
                </div>
              </div>
            </Col>
          </Modal>
        )}
        {/* 顺序排列用拖动 */}
        {/* 新增路线 */}
        <Modal
          title="新增路线"
          width={600}
          open={lineModal}
          onOk={submiteAddLine}
          onCancel={closeModalLine}
        >
          <Form
            layout="horizontal"
            form={addLineForm}
            style={{ marginTop: "20px" }}
            initialValues={addLineFormValues}
            {...layout}
          >
            <Form.Item
              label="巡检厂站"
              name="stationId"
              rules={[{ required: true, message: "请选择巡检厂站" }]}
            >
              <Select placeholder="请选择" onChange={(e) => changStation(e)}>
                {stationData &&
                  stationData.map((item, idx) => {
                    return (
                      <Select.Option
                        value={item.value}
                        key={"stationId-" + idx}
                      >
                        {item.title || item.name}
                      </Select.Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              label="角色"
              name="roleId"
              rules={[{ required: true, message: "请选择角色!" }]}
            >
              <Select placeholder="请选择角色">
                {roleLs.map((item) => {
                  return (
                    <Select.Option value={item.id - 0} key={item.id}>
                      {item.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.List name="deviceRouteInfos">
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => (
                    <div key={field.key} className="add-line-ls">
                      <Form.Item
                        label="设备"
                        name={[field.name, "deviceRelevancyId"]}
                        rules={[{ required: true, message: "请选择设备" }]}
                      >
                        <Cascader options={deviceLs} placeholder="请选择设备" />
                      </Form.Item>
                      <Form.Item
                        label="序号"
                        name={[field.name, "idx"]}
                        rules={[{ required: true, message: "请输入序号!" }]}
                      >
                        <InputNumber min={0} max={10000} />
                      </Form.Item>
                      {fields.length > 1 && (
                        <div className="remove-line-btn">
                          <MinusCircleOutlined
                            onClick={() => {
                              removeLineItem(index);
                            }}
                            style={{ marginLeft: "15px", margin: "10px,0" }}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                  <div className="add-line-btn">
                    <PlusCircleOutlined onClick={addLineItem} />
                  </div>
                </>
              )}
            </Form.List>
          </Form>
        </Modal>
        {/* /新增路线 */}

        {/* 巡检标准详情 */}
        <Modal
          title="巡检标准详情"
          open={infoVisible}
          onCancel={() => setInfoVisible(false)}
          onOk={() => setInfoVisible(false)}
        >
          <div className="defect-detail-bd">
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">巡检标准名称</div>
              <div className="defect-detail-item-desc">{detail.name}</div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">模板类型</div>
              <div className="defect-detail-item-desc">
                {detail.patrolTemplateTypeName}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">巡检厂站</div>
              <div className="defect-detail-item-desc">
                {detail.stationName}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">巡检班组</div>
              <div className="defect-detail-item-desc">
                {detail.handleDeptName}
              </div>
            </div>
            <div className="defect-detail-bd-ls">
              {detail.patrolStandardTemplates &&
                detail.patrolStandardTemplates.length > 0 &&
                detail.patrolStandardTemplates.map((item, index) => {
                  return (
                    <div className="defect-detail-bd-item-level" key={item.id}>
                      <div className="defect-detail-bd-item">
                        <div className="defect-detail-item-lable">
                          -巡检设备
                        </div>
                        <div className="defect-detail-item-desc">
                          {item.deviceRelevancyName}
                        </div>
                      </div>
                      <div className="defect-detail-bd-item">
                        <div className="defect-detail-item-lable">
                          -巡检模板
                        </div>
                        <div className="defect-detail-item-desc">
                          {item.patrolTemplateName}
                        </div>
                      </div>
                      <div className="defect-detail-bd-ls">
                        {item.patrolStandardItems &&
                          item.patrolStandardItems.length > 0 &&
                          item.patrolStandardItems.map((subItem) => {
                            return (
                              <div
                                className="defect-detail-bd-item-level"
                                key={subItem.id}
                              >
                                <div className="defect-detail-bd-item">
                                  <div className="defect-detail-item-lable">
                                    --缺陷等级
                                  </div>
                                  <div className="defect-detail-item-desc">
                                    {subItem.defectLevelName}
                                  </div>
                                </div>
                                <div className="defect-detail-bd-item">
                                  <div className="defect-detail-item-lable">
                                    --巡检内容
                                  </div>
                                  <div className="defect-detail-item-desc">
                                    {subItem.itemContent}
                                  </div>
                                </div>
                                <div className="defect-detail-bd-item">
                                  <div className="defect-detail-item-lable">
                                    --是否填写数值
                                  </div>
                                  <div className="defect-detail-item-desc">
                                    {subItem.numericFlag ? "是" : "否"}
                                  </div>
                                </div>
                                {subItem.unit && (
                                  <>
                                    <div className="defect-detail-bd-item">
                                      <div className="defect-detail-item-lable">
                                        --单位
                                      </div>
                                      <div className="defect-detail-item-desc">
                                        {subItem.unit}
                                      </div>
                                    </div>
                                    <div className="defect-detail-bd-item">
                                      <div className="defect-detail-item-lable">
                                        --上限值
                                      </div>
                                      <div className="defect-detail-item-desc">
                                        {subItem.upperLimit}
                                      </div>
                                    </div>
                                    <div className="defect-detail-bd-item">
                                      <div className="defect-detail-item-lable">
                                        --下限值
                                      </div>
                                      <div className="defect-detail-item-desc">
                                        {subItem.lowerLimit}
                                      </div>
                                    </div>
                                  </>
                                )}
                                <div className="defect-detail-bd-item">
                                  <div className="defect-detail-item-lable">
                                    --运行状态
                                  </div>
                                  <div className="defect-detail-item-desc">
                                    {runStatusEnum[subItem.runStatusStr]}
                                  </div>
                                </div>
                                <div className="defect-detail-bd-item">
                                  <div className="defect-detail-item-lable">
                                    --安全隐患
                                  </div>
                                  <div className="defect-detail-item-desc">
                                    {subItem.safetyPerilFlag ? "是" : "否"}
                                  </div>
                                </div>
                                <div className="defect-detail-bd-item">
                                  <div className="defect-detail-item-lable">
                                    --周期
                                  </div>
                                  <div className="defect-detail-item-desc">
                                    {periodAry[subItem.period]}
                                  </div>
                                </div>
                                <div className="defect-detail-bd-ls">
                                  {subItem.periods &&
                                    subItem.periods.length > 0 &&
                                    subItem.periods.map((values, index) => {
                                      return (
                                        <div
                                          className="defect-detail-bd-item-level"
                                          key={index}
                                        >
                                          {values.beginTime && (
                                            <div className="defect-detail-bd-item">
                                              <div className="defect-detail-item-lable">
                                                --开始时间
                                              </div>
                                              <div className="defect-detail-item-desc">
                                                {values.beginTime}
                                              </div>
                                            </div>
                                          )}
                                          {values.weekDay && (
                                            <div className="defect-detail-bd-item">
                                              <div className="defect-detail-item-lable">
                                                --星期几
                                              </div>
                                              <div className="defect-detail-item-desc">
                                                {values.weekDay}
                                              </div>
                                            </div>
                                          )}
                                          {values.month && (
                                            <div className="defect-detail-bd-item">
                                              <div className="defect-detail-item-lable">
                                                --第几天
                                              </div>
                                              <div className="defect-detail-item-desc">
                                                {values.day}
                                              </div>
                                            </div>
                                          )}
                                          {values.month && values.day && (
                                            <>
                                              <div className="defect-detail-bd-item">
                                                <div className="defect-detail-item-lable">
                                                  --第几月
                                                </div>
                                                <div className="defect-detail-item-desc">
                                                  {values.month}
                                                </div>
                                              </div>
                                              <div className="defect-detail-bd-item">
                                                <div className="defect-detail-item-lable">
                                                  --第几天
                                                </div>
                                                <div className="defect-detail-item-desc">
                                                  {values.day}
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </Modal>
        {/* /巡检标准详情 */}
        {/* 巡检标准模板下载 */}
        <Modal
          open={tmpDownModal}
          title="巡检标准模板下载"
          onOk={() => setTmpDownModal(false)}
          onCancel={() => setTmpDownModal(false)}
        >
          <ul>
            {tmpLs.map((item) => {
              return (
                <li style={{ margin: "20px 0" }} key={item.value}>
                  <span>{item.disName}</span>
                  <Button
                    onClick={() => downTmp(item.value)}
                    style={{ marginLeft: "10px" }}
                    type="primary"
                    size="mini"
                  >
                    下载
                  </Button>
                </li>
              );
            })}
          </ul>
        </Modal>
        {/* /巡检标准模板下载 */}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(InspectionCom);
